import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabPanel, a11yProps } from '../../../../../UI/MuiTab';
import Documents from './Documents/Documents';
import { useTranslation } from 'react-i18next';
import ZSGridProvider from './ZSGridProvider/ZSGridProvider';
import RNGridProvider from './RNGridProvider/RNGridProvider';
import PONUGridProvider from './PONUGridProvider/PONUGridProvider';

const PregledKlijenata = ({ machine }) => {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              label={t('technicalDocumentation')}
              {...a11yProps(0)}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              label={t('instruction')}
              {...a11yProps(1)}
              sx={{ textTransform: 'none' }}
            />
            <Tab
              label={t('administrativeDocumentation')}
              {...a11yProps(2)}
              sx={{ textTransform: 'none' }}
            />
            {machine.tipPregled === 'detalji' && (
              <Tab
                label="Zahtevi za servis"
                {...a11yProps(3)}
                sx={{ textTransform: 'none' }}
              />
            )}
            {machine.tipPregled === 'detalji' && (
              <Tab
                label="Radni nalozi"
                {...a11yProps(4)}
                sx={{ textTransform: 'none' }}
              />
            )}
            {machine.tipPregled === 'detalji' && (
              <Tab
                label="Ponude"
                {...a11yProps(5)}
                sx={{ textTransform: 'none' }}
              />
            )}
          </Tabs>
        </Box>
      </Box>

      <TabPanel value={value} index={0}>
        <Documents idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Documents idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Documents idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ZSGridProvider idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <RNGridProvider idMasine={machine.id} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <PONUGridProvider idMasine={machine.id} />
      </TabPanel>
    </>
  );
};

export default PregledKlijenata;
